import { forwardRef } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { Form as SemanticForm } from "semantic-ui-react";
import { FieldLabel } from "../../FieldLabel";
import { Input } from "../../Input";

/**
 * DEPRECATED - Use design system components instead
 * */
export const FormInput = forwardRef(
  ({ as: As, className = "", id, label = "", ...props }, ref) => (
    <SemanticForm.Field className={clsx("ha-form-input", className)}>
      {label && <FieldLabel htmlFor={id}>{label}</FieldLabel>}
      {As ? (
        <As ref={ref} id={id} {...props} />
      ) : (
        <Input ref={ref} id={id} {...props} />
      )}
    </SemanticForm.Field>
  )
);

FormInput.displayName = "FormInput";

FormInput.propTypes = {
  as: PropTypes.elementType,
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
};
